/**
 * Convercus BI Service
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { KpiValueFormat } from './kpi-value-format';
import { KpiLastRunSchema } from './kpi-last-run-schema';
import { KpiParameterSchema } from './kpi-parameter-schema';
import { ChartConfigurationSchema } from './chart-configuration-schema';
import { ResultMetadataSchema } from './result-metadata-schema';
import { ValidationIssueSchema } from './validation-issue-schema';


export interface KpiVersion { 
    _id: string;
    kpiId: string;
    versionNumber: number;
    createdBy: string;
    previousVersionId?: string;
    sourceArtifactId?: string;
    /**
     * Metric presentation type. A percentage value is a ratio, so 0.25 is shown as 25%: never multiply by 100 in SQL.
     */
    type: KpiVersion.TypeEnum;
    /**
     * How a trend KPI\'s values are formatted. Set on type trend only; null for every other type. A percentage value is a ratio, so 0.25 is shown as 25%: never multiply by 100 in SQL.
     */
    valueFormat?: KpiValueFormat | null;
    sql: string;
    chartConfig: ChartConfigurationSchema | null;
    usedTables: Array<string>;
    usedColumns: Array<string>;
    validationStatus: KpiVersion.ValidationStatusEnum;
    validationIssues: Array<ValidationIssueSchema>;
    /**
     * Non-blocking advice: the version is saved and runs as it is. NO_REPORTING_WINDOW: a count, amount or percentage KPI without a period date range (a dateRange or date column parameter named period), so Compare to has no dates to move on the KPI page; fine for a snapshot. Empty on versions saved before hints existed.
     */
    hints: Array<ValidationIssueSchema>;
    resultMetadata: ResultMetadataSchema;
    parameters: Array<KpiParameterSchema>;
    queryExplanation?: string;
    revisionReason?: string;
    configurationStatus: KpiVersion.ConfigurationStatusEnum;
    /**
     * How long the latest warehouse run of this version took; null until it has run. Cache hits do not count as runs.
     */
    lastRun?: KpiLastRunSchema | null;
}
export namespace KpiVersion {
    export const TypeEnum = {
        Amount: 'amount',
        Count: 'count',
        Chart: 'chart',
        Percentage: 'percentage',
        Trend: 'trend'
    } as const;
    export type TypeEnum = typeof TypeEnum[keyof typeof TypeEnum];
    export const ValidationStatusEnum = {
        Valid: 'valid',
        Invalid: 'invalid'
    } as const;
    export type ValidationStatusEnum = typeof ValidationStatusEnum[keyof typeof ValidationStatusEnum];
    export const ConfigurationStatusEnum = {
        Ok: 'ok',
        NeedsReconfiguration: 'needs_reconfiguration'
    } as const;
    export type ConfigurationStatusEnum = typeof ConfigurationStatusEnum[keyof typeof ConfigurationStatusEnum];
}


